module.exports = __webpack_public_path__ + "img/banner.83c5cd3a.png";